import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { LayoutComponent } from './containers/default-layout/layout/layout.component';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { CadastroLayoutComponent } from './containers/cadastro-layout/cadastro-layout.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TokenInterceptor } from 'src/app/shared/interceptors/tokenInterceptor';
import { Interceptor401 } from 'src/app/shared/interceptors/401interceptor';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UIToolkitModule } from './ui-toolkit/ui-toolkit.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    DefaultLayoutComponent,
    CadastroLayoutComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    InfiniteScrollModule,
    UIToolkitModule,
    IonicModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor401, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// platformBrowserDynamic().bootstrapModule(AppModule);